import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.typed.uint8-array.js";
import { DecodeUTF8, Decompress } from 'fflate';
var decode = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(arrBuffer) {
    var result, utfDecode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            result = '';
            utfDecode = new DecodeUTF8(function (data) {
              result += data;
            });
            utfDecode.push(new Uint8Array(arrBuffer));
            return _context.abrupt("return", result);
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function decode(_x) {
    return _ref.apply(this, arguments);
  };
}();
var decompress = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(arrBuffer) {
    var result, decompressor;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            result = '';
            decompressor = new Decompress(function (chunk) {
              result = chunk;
            });
            decompressor.push(new Uint8Array(arrBuffer));
            return _context2.abrupt("return", result);
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function decompress(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export { decode, decompress };